import { useState } from 'react';
import { useIntl } from 'react-intl';

import { SelectChannelsDialog } from '@/components/pages/job-posting/select-channels-dialog';
import { ErrorStateFallback } from '@/components/ui/error-state';
import { Header } from '@/components/ui/header';

import { Analytics } from './analytics';
import { DashboardTable } from './dashboard-table';
import { Recommendations } from './recommendations';

export function Dashboard() {
  const intl = useIntl();

  const [showAggregateData, setShowAggregateData] = useState(true);
  const dashboardIntl = intl.formatMessage({ defaultMessage: 'Dashboard' });

  return (
    <main className="flex flex-1 flex-col gap-4 px-6 py-2">
      <ErrorStateFallback>
        <Header headers={[{ title: dashboardIntl }]} />
        <Recommendations />
        <Analytics />
        <DashboardTable
          showAggregateData={showAggregateData}
          setShowAggregateData={setShowAggregateData}
        />
        <SelectChannelsDialog />
      </ErrorStateFallback>
    </main>
  );
}
